export const EVAL_UTILISATION_TITLE = 'Évaluation d\'utilisation';

export const EVAL_UTILISATION_HELP_TEXT = (
    <>
        Ce lien URL pointe vers un formulaire d&apos;évaluation (Google Form ou équivalent)
        permettant de former et de tester les connaissances des apprentis sur le bon usage
        de la machine.
        <br /><br />
        Il sert aussi à tracer et à prouver la réalisation de cette formation obligatoire.
    </>
);

export const EVAL_UTILISATION_BUTTON_LABEL = 'Accéder au formulaire d\'évaluation';

export const EVAL_UTILISATION_EMPTY_LABEL = 'Aucun lien d\'évaluation renseigné';
